/*!
 * throttle v4.1.1
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 *
 * Usage exemple
 * $(window).resize(throttle(250, funtion(){}));
 */

(function(window, factory) {
	'use strict';
	// universal module definition

	/*global define: false, module: false, require: false */

	if (typeof define == 'function' && define.amd) {
		// AMD
		define('throttle', factory);
	} else if (typeof module == 'object' && module.exports) {
		// CommonJS
		module.exports = factory(
			window
		);
	} else {
		// browser global
		window._raf = factory(
			window
		);
	}

})(window, function factory(b, c) {

	Math.clamp = function(value, min, max) {
		if (value === undefined) {
			return 0;
		}
		if (min === undefined) {
			min = 0;
		}
		if (max === undefined) {
			max = 1;
		}
		return Math.max(min, Math.min(value, max));
	};

	Math.loopAdd = function(value, to_add, max) {
		value += max + to_add;
		return value % max;
	};

	var out = {};
	out.shuffleArray = function(array) {
		var currentIndex = array.length,
			temporaryValue, randomIndex;
		while (0 !== currentIndex) {
			randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex -= 1;
			temporaryValue = array[currentIndex];
			array[currentIndex] = array[randomIndex];
			array[randomIndex] = temporaryValue;
		}
		return array;
	};

	out.sortByProp = function( prop ) {
		var self = this;
		var args = Array.prototype.slice.call( arguments, 1 );
		return function ( a, b ) {
			var equality = a[prop] - b[prop];
			if ( equality === 0 && arguments.length > 1 ) {
				return self.sortByProp.apply( null, args )( a, b );
			}
			return equality;
		};
	};

	if (window.Promise) {
		out.deferred = function() {
			return new function() {
				this.resolve = null;
				this.reject = null;

				this.promise = new Promise(function(resolve, reject) {
					this.resolve = resolve;
					this.reject = reject;
				}.bind(this));
			};
		};
	}

	return out;



});